<template>
  <Toast />
  <div class="card-header">
    <Toolbar class="mb-0">
      <template #start>
        <h4>Listado de Movimientos</h4>
      </template>
      <template #end>
        <label>Período</label>&nbsp;
        <Calendar id="periodo" aria-describedby="periodo-error" v-model="periodo.label" inputClass="bg-input"
          autocomplete="off" view="month" dateFormat="mm/yy" :showIcon="true" @date-select="selectPeriodo" />
        &nbsp;&nbsp;
      </template>
    </Toolbar>
    <div class="row mt-2">
      <div class="col-md-3">
        <div class="col-12 m-1 p-2 rounded-1 border border-1 bg-white">
          <!-- DT Historico de Movimientos -->
          <DataTable ref="dtr" :value="rmovimientos" :paginator="true" :rows="10"
            style="zoom: 0.80;" :loading="loading"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" :filters="filters"
            responsiveLayout="scroll" breakpoint="990px"
            @rowSelect="selectChofer($event,1)" @rowUnselect="selectChofer($event,1)" selectionMode="single">

            <template #header>          
              <!-- DT Toolbar-->
              <Toolbar class="">
                <template #start>
                  <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                    </span>
                  </div>              
                </template>

                <template #end>
                  <Button label="Todos" icon="pi pi-book" class="p-button-danger" @click="selectChofer($event,0)" />
                </template>
              </Toolbar>
            </template>            

            <Column field="periodo" header="Periodo" :sortable="true" :hidden="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.periodo }}
                </span>
              </template>
            </Column>

            <Column field="rut_dv" header="RUT" style="white-space: nowrap; width: 5%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.rut_dv }}
                </span>
              </template>
            </Column>

            <Column field="name" header="Nombre" style="width: 55%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.name }}
                </span>
              </template>
            </Column>

            <Column field="cant_fletes" header="Cantidad" style="text-align: right; width: 10%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ Number(slotProps.data.cant_fletes).toLocaleString('de-DE') }}
                </span>
              </template>
            </Column>
            <Column field="total_fletes" header="Valor" style="text-align: right; width: 30%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ Number(slotProps.data.total_fletes).toLocaleString('de-DE') }}
                </span>
              </template>
            </Column>
            <ColumnGroup type="footer">
              <Row>
                  <Column style="background:#b4b4b4;text-align:right" footer="Totales:" :colspan="2" />
                  <Column style="background:#b4b4b4;text-align:right" :footer="cant_mvtos"/>
                  <Column style="background:#b4b4b4;text-align:right" :footer="total_rmvtos"/>
              </Row>
          </ColumnGroup>            
          </DataTable>
        </div>
      </div>
      <div class="col-md-9">
        <div class="col-12 m-1 p-2 rounded-1 border border-1 bg-white">
          <DataTable ref="dt" :value="movimientos" :paginator="true" :rows="10" :csvSeparator="';'"
            style="zoom: 0.80;" :loading="loading"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" :filters="filters"
            responsiveLayout="scroll" breakpoint="990px"
            @rowSelect="editMovto($event)" selectionMode="single">

            <template #header>          
              <!-- DT Toolbar-->
              <Toolbar class="">
                <template #start>
                  <div class="table-header flex flex-column md:flex-row md:justiify-content-between">
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                    </span>
                  </div>              
                </template>

                <template #end>
                  <Button label="XLS" icon="pi pi-download" class="p-button-success" @click="exportCSV()" />
                </template>
              </Toolbar>
            </template>     

            <Column field="id" header="ID" style="white-space: nowrap; width: 1%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.id }}
                </span>
              </template>
            </Column>

            <Column field="rut_dv" header="RUT" style="white-space: nowrap; width: 3%;" :sortable="true" v-if="chofer_id === 0">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.rut_dv }}
                </span>
              </template>
            </Column>

            <Column field="chofer" header="Nombre" style="width: 12%;" :sortable="true" v-if="chofer_id === 0">
              <template #body="slotProps">
                <span :title="slotProps.data.chofer">
                  {{ slotProps.data.chofer !== null ? slotProps.data.chofer.substr(0,15)  : '' }}
                </span>
              </template>
            </Column>

            <Column field="fecha" header="Fecha" style="width: 5%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ formatFecha(slotProps.data.fecha) }}
                </span>
              </template>
            </Column>

            <Column field="tipo" header="Tipo" style="white-space: nowrap; width: 5%;" :sortable="true">
              <template #body="slotProps">
                <span :title="slotProps.data.tipo">
                  {{ slotProps.data.tipo !== null ? slotProps.data.tipo.substr(0,15) : '' }}
                </span>
              </template>
            </Column>

            <Column field="tipo_carga" header="" style="width: 3%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.tipo_carga }}
                </span>
              </template>
            </Column>    

            <Column field="patente_camion" header="Patente" style="width: 3%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.patente_camion }}
                </span>
              </template>
            </Column>

            <Column field="rut_emi" header="RUT Emisor" style="white-space: nowrap; width: 3%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.rut_emi ?? slotProps.data.rut_emi }}
                </span>
              </template>
            </Column>

            <Column field="emisor" header="Emisor" style="width: 12%;" :sortable="true" >
              <template #body="slotProps">
                <span :title="slotProps.data.emisor">
                  {{ slotProps.data.emisor !== null ? slotProps.data.emisor.substr(0,20) : '' }}
                </span>
              </template>
            </Column>

            <Column field="rut_recep" header="RUT Receptor" style="white-space: nowrap; width: 3%;" :sortable="true" :hidden="true" :exportable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.rut_recep ?? slotProps.data.rut_recep }}
                </span>
              </template>
            </Column>

            <Column field="receptor" header="Receptor" style="width: 12%;" :sortable="true" :hidden="true" :exportable="true">
              <template #body="slotProps">
                <span :title="slotProps.data.receptor">
                  {{ slotProps.data.receptor ?? slotProps.data.receptor}}
                </span>
              </template>
            </Column>

            <Column field="detalle" header="Producto" style="width: 12%;" :sortable="true" :exportable="true">
              <template #body="slotProps">
                <span :title="slotProps.data.detalle">
                  {{ slotProps.data.detalle !== null ? slotProps.data.detalle.substr(0,20) : '' }}
                </span>
              </template>
            </Column>
            
            <Column field="folio" header="Folio" style="white-space: nowrap; width: 3%;" :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.folio !== null && slotProps.data.folio > 0 ? (slotProps.data.tipodoc !== null ? slotProps.data.tipodoc : '') + ' '+ Number(slotProps.data.folio).toLocaleString('de-DE') : '--'}}
                </span>
              </template>
            </Column>                                         

            <Column field="origen" header="Origen" style="width: 7%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.origen !== null ? slotProps.data.origen.substr(0,20)  : '' }}
                </span>
              </template>
            </Column>                       

            <Column field="destino" header="Destino" style="width: 7%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.destino !== null ? slotProps.data.destino.substr(0,20)  : '' }}
                </span>
              </template>
            </Column>    

            <Column field="valor" header="Valor" style="text-align: right; width: 5%;"
              :sortable="true">
              <template #body="slotProps">
                <span>
                  {{ Number(slotProps.data.valor).toLocaleString('de-DE') }}
                </span>
              </template>
            </Column>  

            <Column field="observacion" header="Observación" :hidden="true" :exportable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.observacion ?? slotProps.data.observacion }}
                </span>
              </template>
            </Column>            

            <Column field="observacion2" header="Observacion 2" :hidden="true" :exportable="true">
              <template #body="slotProps">
                <span>
                  {{ slotProps.data.observacion2 ?? slotProps.data.observacion2 }}
                </span>
              </template>
            </Column>            
            <ColumnGroup type="footer">
              <Row>
                  <Column style="background:#b4b4b4;text-align:right" footer="Totales:" :colspan="chofer_id === 0 ? 13 : 11" />
                  <Column style="background:#b4b4b4;text-align:right" :footer="total_mvtos"/>
              </Row>
          </ColumnGroup>                                            
          </DataTable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useMovimientos from '../../composables/movimientos/movimientos';
import { ref, computed, onMounted } from 'vue'
import moment from "moment"

export default {
  setup() {
    const {
      loading,
      router,
      movimiento,
      movimientos,
      rmovimientos,
      messages,
      filters,
      listaByChofer,
      detalleByChofer
    } = useMovimientos()

    const userLogged = window.Laravel.user

    const dt = ref({})
    const chofer_id = ref()

    const periodo = ref({})
    let periodoSelected = new Date()
    let _periodo

    const dPeriodo = () => {
      return router.currentRoute.value.params.periodo
        ? router.currentRoute.value.params.periodo
        : Number(new Date().getFullYear() + ('0' + (new Date().getMonth() + 1).toString()).slice(-2))
    }

    const selectPeriodo = (e) => {
      periodo.value.val = e !== undefined ? e.getFullYear() + ('0' + (e.getMonth() + 1).toString()).slice(-2) : dPeriodo();
      periodo.value.label = [periodo.value.val.toString().slice(-2), "/", periodo.value.val.toString().slice(0, 4)].join('');

      let arrDate = periodo.value.label.split("/");

      periodoSelected.setDate("01");
      periodoSelected.setMonth(arrDate[0].toString());
      periodoSelected.setFullYear(arrDate[1].toString());
      _periodo = periodo.value.val;
      
      movimientos.value = []
      listaByChofer(periodo.value.val)
    }

    const formatCurrency = (value, style = true) => {
      return style ? new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(Number(value))
        : new Intl.NumberFormat('es-CL').format(Number(value))
    }

    const formatFecha = (value) => {
      return moment(value).format("DD-MM-YY")
    }

    const exportCSV = () => {
      // console.info(dt.value)
      dt.value.exportCSV()
    }

    const selectChofer = (e, from) => {
      chofer_id.value = from === 0 ? 0 : e.data.chofer_id
      sessionStorage.setItem('conductorID', chofer_id.value);
      detalleByChofer(chofer_id.value, periodo.value.val)
    }    

    const editMovto = (mov) => {
      sessionStorage.setItem('periodoSeleccionado', periodo.value.val);
      router.push({ name: 'movimientos.carga', params: { id: mov.data.id} })  
    }

    const cant_mvtos = computed(() => {
      let total = 0;
      for(let mvto of rmovimientos.value) {
        total += Number(mvto.cant_fletes);
      }

      return formatCurrency(total, false);
    });

    const total_rmvtos = computed(() => {
      let total = 0;
      for(let rmvto of rmovimientos.value) {
        total += Number(rmvto.total_fletes);
      }

      return formatCurrency(total);
    });    

    const total_mvtos = computed(() => {
      let total = 0;
      for(let mvto of movimientos.value) {
        total += Number(mvto.valor);
      }

      return formatCurrency(total);
    });    

    onMounted(() => {
      const periodoGuardado = sessionStorage.getItem('periodoSeleccionado');
      if (periodoGuardado) {
        periodo.value.val = periodoGuardado;
        periodo.value.label = [
          periodo.value.val.toString().slice(-2),
          '/',
          periodo.value.val.toString().slice(0, 4)
        ].join('');

        // Preparar estructura de fecha
        let arrDate = periodo.value.label.split('/');
        periodoSelected.setDate('01');
        periodoSelected.setMonth(arrDate[0]);
        periodoSelected.setFullYear(arrDate[1]);
        _periodo = periodo.value.val;

        // Cargar los conductores y movimientos del periodo restaurado
        listaByChofer(periodo.value.val);

        sessionStorage.removeItem('periodoSeleccionado'); // Limpieza
      } else {
        selectPeriodo(); // Solo si no hay un periodo guardado
      }

      const conductorID = sessionStorage.getItem('conductorID');
      if (conductorID) {
        // Simula el click en el chofer para recargar sus movimientos
        selectChofer({ data: { chofer_id: Number(conductorID) } }, 1);
        sessionStorage.removeItem('conductorID')
      }
    });

    return {
      dt,
      chofer_id,
      movimiento,
      movimientos,
      rmovimientos,
      loading,
      userLogged,
      periodo,
      messages,
      periodoSelected,
      filters,
      cant_mvtos,
      total_mvtos, 
      total_rmvtos,   
      editMovto,
      dPeriodo,
      selectPeriodo,
      formatCurrency,
      listaByChofer,
      selectChofer,
      detalleByChofer,
      formatFecha,
      exportCSV,   
    }
  }
}
</script>